import { defineMessages } from 'react-intl';

export default defineMessages({
  dialogTitle: {
    id: 'app.components.MyAccountDialog.dialogTitle',
    defaultMessage: 'Minha conta',
  },
  changeProfile: {
    id: 'app.components.MyAccountDialog.changeProfile',
    defaultMessage: 'Alterar perfil',
  },
  tenantOrBuyer: {
    id: 'app.components.MyAccountDialog.tenantOrBuyer',
    defaultMessage: 'Inquilino ou Comprador',
  },
  owner: {
    id: 'app.components.MyAccountDialog.owner',
    defaultMessage: 'Proprietário',
  },
  indicaAi: {
    id: 'app.components.MyAccountDialog.indicaAi',
    defaultMessage: 'Indica Aí',
  },
  accreditedAgent: {
    id: 'app.components.MyAccountDialog.accreditedAgent',
    defaultMessage: 'Corretor credenciado',
  },
});
